
// React Imports


// Mui Imports

// App Imports

// main function


import {useState, useEffect, createContext} from "react";
import IconButton from "@mui/material/IconButton";
import * as React from "react";
import {Avatar, Card, CardActions, CardContent, CardHeader, Collapse, Grid} from "@mui/material";
import { deepPurple} from "@mui/material/colors";

import Box from "@mui/material/Box";
import {useDispatch, useSelector} from "react-redux";
import {
    executeExpression,
 getCdpHierarchy, getCdpPrimaryAttributes,
    getSourcedCDP
} from "../../ContractDataPoint/ContractDataPointClient";

import {
    advanceApproved,

    advanceContract,
    getMissingInput
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import {
    evaluateUnapproved, updateRelatedContractExpressions,
    updateRelatedExpressions
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDrilldownCDP} from "../../ContractDrilldown/ContractDrilldownCDP/contractDrilldownSliceCDP";
import {changeContractDrilldownCDPV} from "../../ContractDrilldown/ContractDrilldownCDPV/contractDrilldownSliceCDPV";
import Typography from "@mui/material/Typography";
import {changeWorkSubmitting} from "../../Work/workSubmittingSlice";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {changeContractHierarchySearchControls} from "../Header/contractHierarchySearchControlsSlice";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import CDPVGrid from "../../ContractDrilldown/ContractDrilldownCDPV/contractDrilldownCDPVGrid";


export const CDPcontext = createContext();

function WorkQueueCards(props) {
    let [filterContractSectionId, setFilterContractSectionId] = useState(0)
    const [collapsed, setCollapsed] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [gridFilter, setGridFilter] = useState(103);
    const [workQueueCDP, setWorkQueueCDP] = useState([]);
    const [contractData, setContractData] = useState([]);
    // const [cdpFilter, setCdpFilter] = useState('all')
    const [sourceTooltip, setSourceTooltip] = useState([]);

    const [scrollShare, setScrollShare] = useState([]);
    const [folderAttribute, setFolderAttribute] = useState([]);
    const [folderAttributeLength, setFolderAttributeLength] = useState([]);

    const [scroll1, setScroll1] = useState([]);
    const [scroll2, setScroll2] = useState([]);
    const [scroll3, setScroll3] = useState([]);
    const [scroll4, setScroll4] = useState([]);
    const [scroll5, setScroll5] = useState([]);
    const [scroll6, setScroll6] = useState([]);
    const [scroll7, setScroll7] = useState([]);
    const [scroll8, setScroll8] = useState([]);
    const [scroll9, setScroll9] = useState([]);
    const [scroll10, setScroll10] = useState([]);


    const [attribute1, setAttribute1] = useState([]);
    const [attribute2, setAttribute2] = useState([]);
    const [attribute3, setAttribute3] = useState([]);
    const [attribute4, setAttribute4] = useState([]);
    const [attribute5, setAttribute5] = useState([]);
    const [attribute6, setAttribute6] = useState([]);
    const [attribute7, setAttribute7] = useState([]);
    const [attribute8, setAttribute8] = useState([]);
    const [attribute9, setAttribute9] = useState([]);
    const [attribute10, setAttribute10] = useState([]);

    const [selectedCDP, setSelectedCDP] = useState([]);
    //
    // const [selectorContractSectionId, setSelectorContractSectionId] = useState([]);

    const selectorContractSectionId = useSelector((state) => state.workQueueSlc.value.selectedContractSectionId);
    const selectorContractSectionContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);

    const selectorContractStatus = useSelector((state) => state.workQueueSlc.value.selectedContractStatus);
    const selectorContractProperty = useSelector((state) => state.workQueueSlc.value.selectedContractProductId);
    const selectorContractLevel = useSelector((state) => state.workQueueSlc.value.selectedContractLevel);
    const selectorContractGuild = useSelector((state) => state.workQueueSlc.value.selectedContractGuild);

    const selectorInputMissingCount = useSelector((state) => state.workQueueSlc.value.selectedContractInputMissingCount);

    const cdpFilter = useSelector((state) => state.workQueueSlc.value.workQueueCDPGridPencil);

    const selectorTriggerAdvance = useSelector((state) => state.workQueueSlc.value.triggerAdvance);

    const [sortData, setSortData] = useState([]);
    const dispatchData = useDispatch();

    const [contractFolders, setContractFolders] = useState([]);


    const handleCards = () => {

        dispatchData(changeContractHierarchySearchControls({contractHierarchySearchState: false
        }));
        dispatchData(changeWorkQueue({contractHeaderState: true, cardsState: false
        }));

    }

    function selectorContractData(){};


    const handleFilter = () => {
        if (cdpFilter === 'all') {
            dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'red'}));
        }
        if (cdpFilter === 'red') {
            dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'blue'}));
        }
        if (cdpFilter=== 'blue') {
            dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'black'}));
        }
        if (cdpFilter === 'black') {
            dispatchData(changeWorkQueue({workQueueCDPGridPencil: 'all'}));
        }
    }

    // useEffect(() => {
    //     console.log("CDP fetch triggered by cdp filter");
    //     fetchWorkQueueCDP();
    //     // dispatchDataPointValue(changeDataPointValue({dpvGridRefresh: false}));
    // }, [cdpFilter]);
    //

    // useEffect(() => {
    //     fetchWorkQueueCDP();
    //
    //     console.log("CDP fetch triggered by drawer state");
    //     console.log("Contract ID");
    //     console.log(selectorContractSectionContractId);
    //     console.log("Data");
    //     console.log(workQueueCDP);
    // }, [useSelector((state) => state.workQueueSlc.value.workQueueDrawerState) === false]);

    const fetchContractFolders  = () => {
        console.log("hierarchy contract id ", selectorContractId );
        if(selectorContractId > 0)
        {getCdpHierarchy(selectorContractId)

            .then(data => {
                console.log("Hierarchy data");
                console.log(data);
                // setDrilldownCDP(data);
                // setAllCDPs(data);
                setContractFolders(data);
                setFolderTabValue(-1);})}
        else{setContractFolders([])}
    }
    useEffect(() => {
        console.log("Contract Folders load triggered");
        fetchContractFolders();
    }, [selectorContractId]);

    const fetchWorkQueueCDP = () => {
        if (selectorContractId != null
            // && selectorContractId !== 0
        ) {
            getSourcedCDP(selectorContractId)

                .then(data => {
                    console.log("for Contract #", selectorContractId);
                    console.log("CDP data set retrieved");
                    console.log(data);
                    // setSortData(data.sort((data)=> data.primaryAttribute));
                    // console.log("sortData");
                    // console.log(sortData);
                    // setScrollShare(data.filter(data => data.primaryAttribute ===  'Share').sort((a,b)=> a.releaseToMarket>b.releaseToMarket));
                    // setDrilldownCDP(data);
                    // setAllCDPs(data);
                    // setWorkQueueCDP(data.filter(data => data.hierarchy === 'Configurations'));
                    setWorkQueueCDP(data.filter(data => data.contractSectionId === selectorContractSectionId).sort((a,b)=> a.dataPointName>b.dataPointName));


                })
                // .then(fetchPrimaryAttributes)
                //     getCdpPrimaryAttributes(selectorContractId))
                // .then(res1 => res1.data)
                // .then(data => {
                //     console.log("for Contract #", selectorContractId);
                //     console.log("CDP attribute data set retrieved");
                //     console.log(data);
                //     // setFolderAttribute(data.sort((data) => data.primaryAttribute));
                //     // console.log("sortData");
                //     // console.log(sortData);
                //     setFolderAttribute(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                //     setAttribute1(data.attributeName[0]);
                //     setScroll1(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === data.attributeName[0]).sort((a, b) => a.dataPointName > b.dataPointName))
                // })
        // };
    }};
    useEffect(() => {
        console.log("Contract Folders CDP load triggered");
        fetchWorkQueueCDP();
    }, [selectorContractSectionId]);


    const [folderTabValue, setFolderTabValue] = React.useState(-1);

    const handleFolderTabChange = (event, newValue) => {
        console.log("event ",event);
        console.log("newValue ", newValue);
        console.log(contractFolders.filter(contractFolders => contractFolders.folderName === newValue));
        // console.log(contractFolders.filter(contractFolders => contractFolders.folderName === newValue).folderId[0]);
        console.log(contractFolders.find(contractFolders => contractFolders.folderName === newValue).folderId);
        // console.log(array.prototype.map(contractFolders.filter(contractFolders => contractFolders.folderName === newValue) =>
        // contractFolders.filter(contractFolders => contractFolders.folderName === newValue).folderId) );
        setFolderTabValue(newValue);
        dispatchData(changeWorkQueue({
            selectedContractSectionId: (contractFolders.find(contractFolders => contractFolders.folderName === newValue).folderId)
        }));

    }


    useEffect(() => {
        console.log('the workQueueCDP has changed', workQueueCDP)


    // const fetchPrimaryAttributes = () => {
        if (selectorContractId != null
            // && selectorContractId !== 0
        ) {
            getCdpPrimaryAttributes(selectorContractId)

                .then(data => {
                    console.log("for Contract #", selectorContractId);
                    console.log("CDP attribute data set retrieved");
                    console.log(data);
                    // setFolderAttribute(data.sort((data) => data.primaryAttribute));
                    // console.log("sortData");
                    // console.log(sortData);
                    setFolderAttribute(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                    setFolderAttributeLength(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName).length);

                    console.log("folderAttribute list");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                    console.log("folderAttribute length");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName).length);

                    setAttribute1(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[0]);
                    setAttribute2(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[1]);
                    setAttribute3(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[2]);
                    setAttribute4(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[3]);
                    setAttribute5(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[4]);
                    setAttribute6(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[5]);
                    setAttribute7(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[6]);
                    setAttribute8(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[7]);
                    setAttribute9(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[8]);
                    setAttribute10(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[9]);


                    console.log("attribute 1");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[0]);
                    console.log("attribute 2");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[1]);
                    console.log("attribute 3");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[2]);
                    console.log("attribute 4");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[3]);
                    console.log("attribute 5");
                    console.log(data.filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName)[4]);
                    // console.log("attribute 2");
                    // console.log(data[2].filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                    // console.log("attribute 3");
                    // console.log(data[3].filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                    // console.log("attribute 4");
                    // console.log(data[4].filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                    // console.log("attribute 5");
                    // console.log(data[5].filter(data => data.folderId === selectorContractSectionId).sort((a, b) => a.attributeName > b.attributeName));
                    console.log("atribute logging");
                    console.log("selector contract id");
                    console.log(selectorContractId);
                    console.log("work queue");
                    console.log(workQueueCDP);
                    // setScroll1(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute2).sort((a, b) => a.dataPointName > b.dataPointName))
                    // console.log("scroll 1");
                    // console.log(scroll1);
                    console.log(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute1).sort((a, b) => a.dataPointName > b.dataPointName))
                    // console.log(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === data[1].attributeName).sort((a, b) => a.dataPointName > b.dataPointName))
                    // console.log(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === data[2].attributeName).sort((a, b) => a.dataPointName > b.dataPointName))
                    // console.log(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === data[3].attributeName).sort((a, b) => a.dataPointName > b.dataPointName))
                })}}
    // , [selectorContractSectionId]);
, [workQueueCDP]);



    useEffect(() => {
            console.log("getting scroll data");
            console.log("selector contract id");
            console.log(selectorContractId);
            console.log("selectorContractSectionId");
            console.log(selectorContractSectionId);
            console.log("folderAttributeLength");
            console.log(folderAttributeLength);
            console.log("work queue");
            console.log(workQueueCDP);
            console.log('attribute1', attribute1)
            console.log('attribute2 has changed', attribute2);
                if (folderAttributeLength > 0) {
                    console.log("scroll 1 triggered");
            setScroll1(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute1.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 1) {
            setScroll2(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute2.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 2) {
            setScroll3(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute3.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 3) {
            setScroll4(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute4.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 4) {
            setScroll5(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute5.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 5) {
            setScroll6(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute6.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 6) {
            setScroll7(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute7.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
        if (folderAttributeLength > 7) {
            setScroll8(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute8.attributeName).sort((a, b) => a.dataPointName > b.dataPointName))
        }
        if (folderAttributeLength > 8) {
            setScroll9(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute9.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
        }
            if (folderAttributeLength > 9) {
                setScroll10(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute10.attributeName).sort((a, b) => a.dataPointName > b.dataPointName));
            };
                        console.log("scroll 1");
                        console.log(scroll1);
                        console.log(workQueueCDP.filter(workQueueCDP => workQueueCDP.primaryAttribute === attribute1.attributeName).sort((a, b) => a.dataPointName > b.dataPointName))
                    }
        , [attribute1]);
// , [folderAttributeLength]);


    const [submitting, setSubmitting] = useState(false);
    // const [advancing, setAdvancing] = useState(false);

    function handleAdvance(callback) {
        if (selectorContractId != null
            && selectorContractId !== 0 &&
            (selectorContractStatus === "NEW" || selectorContractStatus === "Unapproved" || selectorContractStatus === undefined  )
        ) {
            console.log("standard advance triggered");
            console.log("selectorContractId",selectorContractId);
            console.log("selectorContractStatus",selectorContractStatus);
            console.log("selectorContractProperty",selectorContractProperty);
            console.log("selectorContractLevel",selectorContractLevel);
            console.log("selectorContractGuild",selectorContractGuild);
            setSubmitting(true);
            dispatchData(changeWorkSubmitting({submitting: true }));
            // setAdvancing(true);
            advanceContract(selectorContractId).then(() => {
                // callback(fetchWorkQueueCDP);
                // setAdvancing(false);
                fetchWorkQueueCDP();
                // dispatchData(changeWorkQueue({workQueueAdvanceState: true}));
                // console.log("Advance Contract: ",selectorContractId );
                // console.log(selectorContractId);
            })

                .then(() => {
                    dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
                })
                .finally(() => {
                    setSubmitting(false);
                    dispatchData(changeWorkSubmitting({submitting: false }));
                })
        }
        if (selectorContractId != null
            && selectorContractId !== 0 &&
            selectorContractStatus === "Approved"
        ){              setSubmitting(true);
            console.log("advance approved triggered");
            console.log("selectorContractId",selectorContractId);
            console.log("selectorContractStatus",selectorContractStatus);
            console.log("selectorContractProperty",selectorContractProperty);
            console.log("selectorContractLevel",selectorContractLevel);
            console.log("selectorContractGuild",selectorContractGuild);

            advanceApproved(selectorContractId).then(() => {
                // callback(fetchWorkQueueCDP);
                // setAdvancing(false);
                fetchWorkQueueCDP();})
                .finally(() => {
                    setSubmitting(false)
                })
        }else{console.log("Advance Failed");
            console.log("selectorContractId", selectorContractId);
            console.log("selectorContractStatus", selectorContractStatus);};
    };


    const triggerAdvance = selectorContractId => {
        if (selectorContractId !== 0) {
            console.log("advance triggered by triggerAdvance")
            handleAdvance();
        }
    }

    useEffect(() => {
        if(selectorTriggerAdvance === true)
        {
            console.log("Advance triggered by workQueueSlc.value.triggerAdvance = true");
            triggerAdvance()
            // handleAdvance();
            dispatchData(changeWorkQueue({triggerAdvance: false}));}
    }, [useSelector((state) => state.workQueueSlc.value.triggerAdvance === true)]);



    const renderContractDataPoints2 = workQueueCDP => {
        if (workQueueCDP.length <= 0) {
            return "No Data";
        }
    }

    const handleExpression = (cdp_id, cs_id, callback) => {
        executeExpression(cdp_id).then(() => {
            callback(fetchWorkQueueCDP);
            console.log("Execute Expression");
        });
        // dispatchContractSection(changeContractDataPoint({contractSectionId: cs_id}));
        // setSelectedSection(cs_id);
        // executeExpression()
    };




    const handleEdit = (rowData) => {
        dispatchData(changeWorkQueue({cdpId: rowData.id, dataPointName: rowData.dataPointName,  dataType: rowData.dataType, value: rowData.mockValue,workQueueDrawerState: true,
            workQueueNewState: false, workQueueAdvanceState: false,
            selectedCdpId: rowData.id,
            selectedCdpDataPointId: rowData.dataPointId,
            selectedCdpDataPointName: rowData.dataPointName,
            selectedCdpDataType: rowData.dataType,
            selectedCdpMockValue: rowData.cdpvDisplayValue,
            selectedCdpValue: rowData.value,
            selectedCdpMockOrigin: rowData.origin}));
        // dispatchData(changeWorkQueue({workQueueDrawerState: true}));
        console.log("Begin edit");
        console.log("Work Queue Drawer State Updated to True");
        console.log("selected contract id at open");
        console.log("input missing count", selectorInputMissingCount);
        console.log("selectorContractId", selectorContractId);

        getMissingInput(selectorContractId)
            .then(function (res) {
                    dispatchData(changeWorkQueue({selectedContractId: selectorContractId, selectedContractInputMissingCount: res.data}));
                    console.log("my new input missing count =",res.data );
                }

            );
    }


    const handleExploreCDPV = (selectedCDP) => {
        console.log("explore cdpv clicked");
        console.log("selectedCDP id ", selectedCDP.id);
        console.log("multi-value cdpv should display now.")
        dispatchData(changeContractDrilldownCDP({id: selectedCDP.id}));
        dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
    };



    function onChange(pagination, filters, sorter, extra) {
        console.log('params', pagination, filters, sorter, extra);
    }
    // function DetailPanelContent({ row: workQueueCDP }) {
    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
            // <div>{id}</div>
        )}


    const getDetailPanelHeight = React.useCallback(() => 300, []);

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={workQueueCDP.id} />,
        [],
    );


    const [expanded, setExpanded] = React.useState(-1);

    const handleExpandClick = i => {
        setExpanded(expanded === i ? -1 : i);
    };

    const ExpandMore = styled((props) => {
        const { expand, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand }) => ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));

    const [expanded1, setExpanded1] = React.useState(-1);

    const handleExpandClick1 = i1 => {
        setExpanded1(expanded1 === i1 ? -1 : i1);
    };
    const ExpandMore1 = styled((props) => {
        const { expand1, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand1 }) => ({
        transform: !expand1 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded2, setExpanded2] = React.useState(-1);

    const handleExpandClick2 = i2 => {
        setExpanded2(expanded2 === i2 ? -1 : i2);
    };
    const ExpandMore2 = styled((props) => {
        const { expand2, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand2 }) => ({
        transform: !expand2 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded3, setExpanded3] = React.useState(-1);

    const handleExpandClick3 = i3 => {
        setExpanded3(expanded3 === i3 ? -1 : i3);
    };
    const ExpandMore3 = styled((props) => {
        const { expand3, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand3 }) => ({
        transform: !expand3 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded4, setExpanded4] = React.useState(-1);

    const handleExpandClick4 = i4 => {
        setExpanded4(expanded4 === i4 ? -1 : i4);
    };
    const ExpandMore4 = styled((props) => {
        const { expand4, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand4 }) => ({
        transform: !expand4 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded5, setExpanded5] = React.useState(-1);

    const handleExpandClick5 = i5 => {
        setExpanded5(expanded5 === i5 ? -1 : i5);
    };
    const ExpandMore5 = styled((props) => {
        const { expand5, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand5 }) => ({
        transform: !expand5 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded6, setExpanded6] = React.useState(-1);

    const handleExpandClick6 = i6 => {
        setExpanded6(expanded6 === i6 ? -1 : i6);
    };
    const ExpandMore6 = styled((props) => {
        const { expand6, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand6 }) => ({
        transform: !expand6 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded7, setExpanded7] = React.useState(-1);

    const handleExpandClick7 = i7 => {
        setExpanded7(expanded7 === i7 ? -1 : i7);
    };
    const ExpandMore7 = styled((props) => {
        const { expand7, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand7 }) => ({
        transform: !expand7 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded8, setExpanded8] = React.useState(-1);

    const handleExpandClick8 = i8 => {
        setExpanded8(expanded8 === i8 ? -1 : i8);
    };
    const ExpandMore8 = styled((props) => {
        const { expand8, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand8 }) => ({
        transform: !expand8 ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded9, setExpanded9] = React.useState(-1);

    const handleExpandClick9 = i9 => {
        setExpanded9(expanded9 === i9 ? -1 : i9);
    };
    const ExpandMore9 = styled((props) => {
        const { expand9, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand9 }) => ({
        transform: !expand9 ? 'rotate(0deg)' : 'rotate(190deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));


    const [expanded10, setExpanded10] = React.useState(-1);

    const handleExpandClick10 = i10 => {
        setExpanded10(expanded10 === i10 ? -1 : i10);
    };
    const ExpandMore10 = styled((props) => {
        const { expand10, ...other } = props;
        return <IconButton {...other} />;
    })(({ theme, expand10 }) => ({
        transform: !expand10 ? 'rotate(0deg)' : 'rotate(1100deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    }));

// https://www.codinn.dev/articles/react-cards
    function HorizontalScroll(props) {
        return <div className="horizontal-scroll-container"

        >{props.children}</div>;
    }



    // function getDetailPanelContent() { return(<div>pppppp {workQueueCDP.mockIndicator}</div>);}
// https://stackoverflow.com/questions/63705571/rendering-material-ui-cards-dynamically-in-a-row
    return (
        <div style={{marginLeft: '20px', height: '100%' , width: '100%' }}>
            {/*<br/>*/}
            {/*<br/>*/}
            {/*<br/>*/}
            <br/>
            {/*<ListIcon  onClick= {() => handleCards()}/>*/}
{/*            <HorizontalScroll>*/}
{/*                {contractFolders.map( (stuff, i) => (*/}
{/*<Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>*/}
{/*    <Tabs value={folderTabValue} defaultValue={null} onChange={handleFolderTabChange} centered>*/}
{/*                    <Tab value={stuff.folderName}  label={stuff.folderName}/>*/}
{/*    </Tabs>*/}
{/*</Box>*/}
{/*                    // <Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.attributeId}>*/}
{/*                    //     <Typography sx={{pl: 3, pr: 3 }}*/}
{/*                    //                 color={'primary'}>{stuff.attributeName}</Typography>*/}
{/*                    // </Grid>*/}
{/*                    ))}*/}
{/*                    </HorizontalScroll>*/}

            <HorizontalScroll>
                <Box sx={{ pt: 2, bgcolor: 'background.paper' }}>
                    <Tabs
                        value={folderTabValue}
                        onChange={handleFolderTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        {contractFolders.map((stuff) => (
                            <Tab
                                key={stuff.folderName}
                                value={stuff.folderName}
                                label={stuff.folderName}
                            />
                        ))}
                    </Tabs>
                </Box>
            </HorizontalScroll>



            {/*{*/}
            {/*    workQueueCDP.map( stuff => (*/}
            {/*// {(workQueueCDP) => (*/}
            {/*<div>*/}
            {/*    <HorizontalScroll>*/}
            {/*        <Card>*/}
            {/*            <h2>Title 1</h2>*/}
            {/*            <p>Description 1</p>*/}
            {/*        </Card>*/}
            {/*        <Card>*/}
            {/*            <h2>Title 2</h2>*/}
            {/*            <p>Description 2</p>*/}
            {/*        </Card>*/}
            {/*        <Card>*/}
            {/*            <h2>Title 3</h2>*/}
            {/*            <p>Description 3</p>*/}
            {/*        </Card>*/}
            {/*    </HorizontalScroll>*/}
            {/*</div>*/}
            <br/>
            {/*<br/>*/}
            {/*<br/>*/}
            {folderAttributeLength > 0 &&
            <div >
                {attribute1.attributeName === null &&
                <h2>uncategorized ({attribute1.cdpCount})</h2>}
                {attribute1.attributeName !== null &&
                    <h2>{attribute1.attributeName} ({attribute1.cdpCount})</h2>}
                {/*<HorizontalScroll>*/}
                {/*    {scroll1.map( (stuff, i1) => (*/}
                {/*        <Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}*/}
                {/*        >*/}
                <HorizontalScroll>
                <Grid
                    container
                    wrap="nowrap"
                    sx={{
                        overflowX: 'auto',
                        // optional: hide vertical scrollbars
                        overflowY: 'hidden',
                    }}
                >
                    {scroll1.map((stuff, i1) => (
                        <Grid
                            item
                            key={stuff.id}
                            sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                        >
                            <Card elevation = {3} sx={{width: 200}}
                                  style = {{backgroundColor: "rgb(135,206,250)"}}
                            >
                                <CardHeader
                                    titleTypographyProps={{ fontSize: 16,  color: '#333' }}
                                    subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                    subheader={stuff.dataPointName}
                                    sx={{
                                        backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                        paddingY: 1.5,
                                        paddingX: 2,
                                        '& .MuiCardHeader-subheader': {
                                            color: '#333',               // optional: tweak subheader color
                                            // fontWeight: 'bold',
                                        },
                                    }}
                               />
                                <CardContent>
                                    <div>
                                        {stuff.cdpvCount > 1 &&
                                            <Avatar
                                                onClick= {() => handleExploreCDPV(stuff)}
                                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                        }
                                        {stuff.cdpvCount === 1 &&
                                            stuff.mockValue
                                        }
                                    </div>
                                    <br/>
                                    {/*<Typography sx={{fontSize: 12}} >*/}
                                    {/*    {stuff.primaryAttribute}*/}
                                    {/*</Typography>*/}
                                    <Typography sx={{fontSize: 12}} >
                                        {stuff.releaseToMarket}
                                    </Typography>
                                </CardContent>
                                <CardActions disableSpacing
                                >
                                    {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                    <ExpandMore1
                                        expand={expanded1}
                                        onClick={()=>handleExpandClick1(i1)}
                                        aria-expanded={expanded1 === i1}
                                        aria-label="show more1"
                                    >
                                        <ExpandMoreIcon />
                                    </ExpandMore1>
                                </CardActions>
                                <Collapse in={expanded1 === i1} timeout="auto" unmountOnExit>
                                    <CardContent
                                        sx={{
                                            backgroundColor: 'lightblue'
                                        }}
                                    >
                                        <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                        <Typography sx={{fontSize: 12}}>
                                            {stuff.contractName}
                                        </Typography>
                                        <br/>
                                        <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                        <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                    </CardContent>
                                </Collapse>
                            </Card>
                        </Grid>
                        ))}
                </Grid>
            </HorizontalScroll>
                    {/*    </Grid>*/}
                    {/*))}*/}
                {/*</HorizontalScroll>*/}
                <br/>
            </div>}
            {folderAttributeLength > 1 &&
                <div>
                <h2>
                    {attribute2.attributeName} ({attribute2.cdpCount})
                </h2>
                <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll2.map((stuff, i2) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                        {/*<Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}*/}
                        {/*>*/}
                            <Card elevation = {3} sx={{width: 200}}
                                  style = {{backgroundColor: "rgb(135,206,250)"}}
                            >
                                <CardHeader
                                    titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                    subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                    subheader={stuff.dataPointName}
                                    sx={{
                                        backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                        paddingY: 1.5,
                                        paddingX: 2,
                                        '& .MuiCardHeader-subheader': {
                                            color: '#333',               // optional: tweak subheader color
                                            // fontWeight: 'bold',
                                        },
                                    }}
                                />
                                <CardContent>
                                    <div>
                                        {stuff.cdpvCount > 1 &&
                                            <Avatar
                                                onClick= {() => handleExploreCDPV(stuff)}
                                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                        }
                                        {stuff.cdpvCount === 1 &&
                                            stuff.mockValue
                                        }
                                    </div>
                                    <br/>
                                    {/*<Typography sx={{fontSize: 12}} >*/}
                                    {/*    {stuff.primaryAttribute}*/}
                                    {/*</Typography>*/}
                                    <Typography sx={{fontSize: 12}} >
                                        {stuff.releaseToMarket}

                                    </Typography>
                                </CardContent>
                                <CardActions disableSpacing>
                                    {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                    <ExpandMore2
                                        expand={expanded2}
                                        onClick={()=>handleExpandClick2(i2)}
                                        aria-expanded={expanded2 === i2}
                                        aria-label="show more2"
                                    >
                                        <ExpandMoreIcon />
                                    </ExpandMore2>
                                </CardActions>
                                <Collapse in={expanded2 === i2} timeout="auto" unmountOnExit>
                                    <CardContent
                                        sx={{
                                            backgroundColor: 'lightblue'
                                        }}
                                    >
                                        <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                        <Typography sx={{fontSize: 12}}>
                                            {stuff.contractName}
                                        </Typography>
                                        <br/>
                                        <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                        <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                    </CardContent>
                                </Collapse>
                            </Card>
                                </Grid>
                            ))}
                        </Grid>
                </HorizontalScroll>
                <br/>
            </div>}
            {folderAttributeLength > 2 &&
                <div>
                <h2>{attribute3.attributeName} ({attribute3.cdpCount})</h2>
                <HorizontalScroll>
                    <Grid
                        container
                        wrap="nowrap"
                        sx={{
                            overflowX: 'auto',
                            // optional: hide vertical scrollbars
                            overflowY: 'hidden',
                        }}
                    >
                        {scroll3.map((stuff, i3) => (
                            <Grid
                                item
                                key={stuff.id}
                                sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                            >

                            {/*{scroll3.map( (stuff, i3) => (*/}
                    {/*    <Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}>*/}
                            <Card elevation = {3} sx={{width: 200}}
                                  style = {{backgroundColor: "rgb(135,206,250)"}}
                            >
                                <CardHeader
                                    titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                    subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                    subheader={stuff.dataPointName}
                                    sx={{
                                        backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                        paddingY: 1.5,
                                        paddingX: 2,
                                        '& .MuiCardHeader-subheader': {
                                            color: '#333',               // optional: tweak subheader color
                                            // fontWeight: 'bold',
                                        },
                                    }}
                                   />
                                <CardContent>
                                    <div>
                                        {stuff.cdpvCount > 1 &&
                                            <Avatar
                                                onClick= {() => handleExploreCDPV( stuff)}
                                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                        }
                                        {stuff.cdpvCount === 1 && stuff.mockValue}
                                    </div>
                                    <br/>
                                    {/*<Typography sx={{fontSize: 12}} >*/}
                                    {/*    {stuff.primaryAttribute}*/}
                                    {/*</Typography>*/}
                                    <Typography sx={{fontSize: 12}} >
                                        {stuff.releaseToMarket}
                                    </Typography>
                                </CardContent>
                                <CardActions disableSpacing>
                                    {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                    <ExpandMore3
                                        expand={expanded3}
                                        onClick={()=>handleExpandClick3(i3)}
                                        aria-expanded={expanded3 === i3}
                                        aria-label="show more3"
                                    >
                                        <ExpandMoreIcon />
                                    </ExpandMore3>
                                </CardActions>
                                <Collapse in={expanded3 === i3} timeout="auto" unmountOnExit>
                                    <CardContent
                                        sx={{
                                            backgroundColor: 'lightblue'
                                        }}
                                    >
                                        <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                        <Typography sx={{fontSize: 12}}>
                                            {stuff.contractName}
                                        </Typography>
                                        <br/>
                                        <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                        <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                    </CardContent>
                                </Collapse>
                            </Card>
                            </Grid>
                        ))}
                    </Grid>
                </HorizontalScroll>
                </div>}

            {folderAttributeLength > 3 &&
                <div>
                    <h2>{attribute4.attributeName} ({attribute4.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll4.map((stuff, i4) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                                <Card elevation = {3} sx={{width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore4
                                            expand={expanded4}
                                            onClick={()=>handleExpandClick4(i4)}
                                            aria-expanded={expanded4 === i4}
                                            aria-label="show more"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore4>
                                    </CardActions>
                                    <Collapse in={expanded4 === i4} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                </div>}

            {folderAttributeLength > 4 &&
                <div>
                    <h2>{attribute5.attributeName} ({attribute5.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll5.map((stuff, i5) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                        {/*{scroll5.map( (stuff, i5) => (*/}
                        {/*    <Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}>*/}
                                <Card elevation = {3} sx={{width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore5
                                            expand={expanded5}
                                            onClick={()=>handleExpandClick5(i5)}
                                            aria-expanded={expanded5 === i5}
                                            aria-label="show more5"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore5>
                                    </CardActions>
                                    <Collapse in={expanded5 === i5} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                </div>}

            {folderAttributeLength > 5 &&
                <div>
                    <h2>{attribute6.attributeName} ({attribute6.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll6.map((stuff, i6) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                            {/*    {scroll6.map( (stuff, i6) => (*/}
                            {/*<Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}>*/}
                                <Card elevation = {3} sx={{width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore6
                                            expand={expanded6}
                                            onClick={()=>handleExpandClick6(i6)}
                                            aria-expanded={expanded6 === i6}
                                            aria-label="show more6"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore6>
                                    </CardActions>
                                    <Collapse in={expanded6 === i6} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                </div>}

            {folderAttributeLength > 6 &&
                <div>
                    <h2>{attribute7.attributeName} ({attribute7.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll7.map((stuff, i7) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                            {/*    {scroll7.map( (stuff, i7) => (*/}
                            {/*<Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}>*/}
                                <Card elevation = {3} sx={{width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore7
                                            expand={expanded7}
                                            onClick={()=>handleExpandClick7(i7)}
                                            aria-expanded={expanded7 === i7}
                                            aria-label="show more7"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore7>
                                    </CardActions>
                                    <Collapse in={expanded7 === i7} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                </div>}

            {folderAttributeLength > 7 &&
                <div>
                    <h2>{attribute8.attributeName} ({attribute8.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll8.map((stuff, i8) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                        {/*{scroll8.map( (stuff, i8) => (*/}
                        {/*    <Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}>*/}
                                <Card elevation = {3} sx={{width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore8
                                            expand={expanded8}
                                            onClick={()=>handleExpandClick8(i8)}
                                            aria-expanded={expanded8 === i8}
                                            aria-label="show more8"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore8>
                                    </CardActions>
                                    <Collapse in={expanded8 === i8} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                </div>}

            {folderAttributeLength > 8 &&
                <div>
                    <h2>{attribute9.attributeName} ({attribute9.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll9.map((stuff, i9) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                        {/*{scroll9.map( (stuff, i9) => (*/}
                        {/*    <Grid sx={{pt: 1, pb:3}} item xs={3} key={stuff.id}>*/}
                                <Card elevation = {3} sx={{
                                    width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore9
                                            expand={expanded9}
                                            onClick={()=>handleExpandClick9(i9)}
                                            aria-expanded={expanded9 === i9}
                                            aria-label="show more9"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore9>
                                    </CardActions>
                                    <Collapse in={expanded9 === i9} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                </div>}

            {folderAttributeLength > 9 &&
                <div>
                    <h2>{attribute10.attributeName} ({attribute10.cdpCount})</h2>
                    <HorizontalScroll>
                        <Grid
                            container
                            wrap="nowrap"
                            sx={{
                                overflowX: 'auto',
                                // optional: hide vertical scrollbars
                                overflowY: 'hidden',
                            }}
                        >
                            {scroll10.map((stuff, i10) => (
                                <Grid
                                    item
                                    key={stuff.id}
                                    sx={{ pt: 1, pb: 3, pr: 2 }} // spacing between cards
                                >

                            {/*    {scroll10.map( (stuff, i10) => (*/}
                            {/*<Grid sx={{pt: 1, pb:3,display: 'flex' }} item xs={3} key={stuff.id}>*/}
                                <Card elevation = {3} sx={{width: 200}}
                                      style = {{backgroundColor: "rgb(135,206,250)"}}
                                >
                                    <CardHeader
                                        titleTypographyProps={{ fontSize: 16, fontWeight: 'bold', color: '#333' }}
                                        subheaderTypographyProps={{ fontSize: 16, color: '#666' }}
                                        subheader={stuff.dataPointName}
                                        sx={{
                                            backgroundColor: "rgb(30,144,255)", // or use theme color like 'primary.main'
                                            paddingY: 1.5,
                                            paddingX: 2,
                                            '& .MuiCardHeader-subheader': {
                                                color: '#333',               // optional: tweak subheader color
                                                // fontWeight: 'bold',
                                            },
                                        }}
                                    />
                                    <CardContent>
                                        <div>
                                            {stuff.cdpvCount > 1 &&
                                                <Avatar
                                                    onClick= {() => handleExploreCDPV(stuff)}
                                                    sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                                            }
                                            {stuff.cdpvCount === 1 && stuff.mockValue}
                                        </div>
                                        <br/>
                                        {/*<Typography sx={{fontSize: 12}} >*/}
                                        {/*    {stuff.primaryAttribute}*/}
                                        {/*</Typography>*/}
                                        <Typography sx={{fontSize: 12}} >
                                            {stuff.releaseToMarket}
                                        </Typography>
                                    </CardContent>
                                    <CardActions disableSpacing>
                                        {/*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card */}
                                        <ExpandMore10
                                            expand={expanded10}
                                            onClick={()=>handleExpandClick10(i10)}
                                            aria-expanded={expanded10 === i10}
                                            aria-label="show more10"
                                        >
                                            <ExpandMoreIcon />
                                        </ExpandMore10>
                                    </CardActions>
                                    <Collapse in={expanded10 === i10} timeout="auto" unmountOnExit>
                                        <CardContent
                                            sx={{
                                                backgroundColor: 'lightblue'
                                            }}
                                        >
                                            <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>
                                            <Typography sx={{fontSize: 12}}>
                                                {stuff.contractName}
                                            </Typography>
                                            <br/>
                                            <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>
                                            <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>
                                            <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>
                                        </CardContent>
                                    </Collapse>
                                </Card>
                            </Grid>
                        ))}
                        </Grid>
                    </HorizontalScroll>
                    <CDPVGrid/>
                </div>}
            {/*{folderAttributeLength > 3 &&*/}
            {/*<div>*/}
            {/*    <h2>*/}
            {/*        {attribute4.attributeName}*/}
            {/*    </h2>*/}
            {/*    <HorizontalScroll>*/}
            {/*                    {scroll4.map( (stuff, i) => (*/}
            {/*                        <CdpCardsRow/>))}*/}
            {/*    </HorizontalScroll>*/}
            {/*</div>}*/}
            {/*    <br/>*/}
            {/*    <br/>*/}
            {/*    <br/>*/}
            {/*    <br/>*/}

            {/*    <Grid*/}
            {/*        container*/}
            {/*        spacing={2}*/}
            {/*        direction="row"*/}
            {/*        justify="flex-start"*/}
            {/*        alignItems="flex-start"*/}
            {/*        // item xs={3}*/}
            {/*        // key={stuff.id}*/}
            {/*    >*/}
            {/*        {workQueueCDP.map( (stuff, i) => (*/}
            {/*            <Grid item xs={3} key={stuff.id}*/}
            {/*                  // initialState={{*/}
            {/*                  //     sorting: {*/}
            {/*                  //         sortModel: [{ field: 'dataType', sort: 'asc' }],*/}
            {/*                  //     },*/}
            {/*                  // }}*/}
            {/*            >*/}
            {/*                <Card elevation = {3}>*/}
            {/*                    <CardHeader  subheader={stuff.dataPointName}*/}
            {/*                                // titleTypographyProps ={{fontSize: 12}}*/}
            {/*                    />*/}
            {/*                        /!*frog*!/*/}
            {/*                        /!*{workQueueCDP.name}*!/*/}
            {/*                        /!*{stuff.dataPointName}*!/*/}
            {/*                    <CardContent>*/}
            {/*                        /!*<Typography  >*!/*/}
            {/*                        /!*    /!*frog*!/*!/*/}
            {/*                        /!*    /!*{workQueueCDP.name.map( workQueueCDP)}*!/*!/*/}
            {/*                        /!*    {stuff.primaryAttribute}*!/*/}
            {/*                        /!*</Typography>*!/*/}
            {/*                        <div>*/}
            {/*                            {stuff.cdpvCount > 1 &&*/}
            {/*                        <Avatar*/}
            {/*                        onClick= {() => handleExploreCDPV(workQueueCDP.row.id,  workQueueCDP.row)}*/}
            {/*                        sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>*/}
            {/*                        }*/}
            {/*                            {stuff.cdpvCount === 1 &&*/}
            {/*                                stuff.mockValue*/}
            {/*                        }*/}
            {/*                        </div>*/}
            {/*                    <br/>*/}
            {/*                        /!*<Typography sx={{fontSize: 11}} gutterBottom>*!/*/}
            {/*                        /!*    /!*frog*!/*!/*/}
            {/*                        /!*    /!*{workQueueCDP.name.map( workQueueCDP)}*!/*!/*/}
            {/*                        /!*    /!*{stuff.primaryAttribute}*!/*!/*/}
            {/*                        /!*</Typography>*!/*/}
            {/*                        <Typography sx={{fontSize: 12}} >*/}
            {/*                            /!*frog*!/*/}
            {/*                            /!*{workQueueCDP.name.map( workQueueCDP)}*!/*/}
            {/*                            {stuff.primaryAttribute}*/}
            {/*                        </Typography>*/}
            {/*                        <Typography sx={{fontSize: 12}} >*/}
            {/*                            /!*frog*!/*/}
            {/*                            /!*{workQueueCDP.name.map( workQueueCDP)}*!/*/}
            {/*                            {stuff.releaseToMarket}*/}

            {/*                        </Typography>*/}
            {/*                    </CardContent>*/}
            {/*                    <CardActions disableSpacing>*/}
            {/*                        /!*<IconButton aria-label="add to favorites">*!/*/}
            {/*                        /!*    <FavoriteIcon />*!/*/}
            {/*                        /!*</IconButton>*!/*/}
            {/*                        /!*<IconButton aria-label="share">*!/*/}
            {/*                        /!*    <ShareIcon />*!/*/}
            {/*                        /!*</IconButton>*!/*/}
            {/*                    /!*   https://stackoverflow.com/questions/58953627/react-and-material-ui-how-can-i-expand-only-one-single-card *!/*/}
            {/*                    <ExpandMore*/}
            {/*                        expand={expanded}*/}
            {/*                        onClick={()=>handleExpandClick(i)}*/}
            {/*                            // aria-expanded={expandedId === stuff.id}*/}
            {/*                          aria-expanded={expanded === i}*/}
            {/*                        aria-label="show more"*/}
            {/*                    >*/}
            {/*                        <ExpandMoreIcon />*/}
            {/*                    </ExpandMore>*/}
            {/*                </CardActions>*/}
            {/*                <Collapse in={expanded === i} timeout="auto" unmountOnExit>*/}
            {/*                    <CardContent>*/}
            {/*                        /!*<Typography paragraph>Method:</Typography>*!/*/}
            {/*                        <Typography sx={{fontSize: 12,fontWeight: 'bold'}}>from:</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12}}>*/}
            {/*                            {stuff.contractName}*/}
            {/*                        </Typography>*/}
            {/*                        <br/>*/}
            {/*                                <Typography sx={{fontSize: 12, fontWeight: 'bold'}}>in:</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection10}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection9}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection8}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection7}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection6}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection5}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection4}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection3}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection2}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12, mb:1}}>{stuff.sourceParentSection1}</Typography>*/}
            {/*                        <Typography sx={{fontSize: 12}}>{stuff.sourceSection}</Typography>*/}
            {/*                    </CardContent>*/}
            {/*                </Collapse>*/}
            {/*                </Card>*/}
            {/*            </Grid>*/}
            {/*        ))}*/}
            {/*    </Grid>*/}
        {/*// ))}*/}
        </div>
    );


}
export default WorkQueueCards;



